'use strict';

(function () {
    'use strict';

    angular.module('damages.performInsurerEdi', ['ui.router', 'common']);
})();